import { useContext } from "react";
import { ImperativeDialogContext } from "./dialog-provider.js";

export function useDialog() {
  const context = useContext(ImperativeDialogContext);
  if (!context) {
    throw new Error("useDialog must be used within DialogProvider");
  }
  return context;
}
